"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewNode = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../Colors");
const theme_1 = require("../../editor/theme");
const SharedNode_1 = require("./SharedNode");
const vars_1 = require("../../vars");
const trees_1 = require("../../state/containers/trees");
const index_1 = require("../icons/index");
const NameError = {
    color: Colors_1.Colors.red[0],
};
const NameErrorMessage = {
    position: 'absolute',
    height: 30,
    top: -30,
    color: Colors_1.Colors.red[0],
    width: 600,
    fontSize: 10,
    marginLeft: -10,
    display: 'flex',
    alignItems: 'center',
};
const NodeCreate = {
    color: Colors_1.Colors.grey[0],
    background: 'transparent',
    fontSize: 12,
    padding: `5px 0 5px 10px`,
    border: 0,
    outline: 0,
    fontFamily: vars_1.fontFamily,
    width: 200,
    $nest: {
        '&::placeholder': {
            fontFamily: vars_1.fontFamily,
        },
        '&.NameError': NameError,
    },
};
const MainNodeArea = {
    position: 'relative',
    borderColor: 'transparent',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    cursor: 'pointer',
    transition: `border-color 0.25s ease-in-out`,
    $nest: {
        '.NodeTitle': Object.assign(Object.assign({}, SharedNode_1.NodeTitle), { width: 200, borderBottomLeftRadius: 4, borderBottomRightRadius: 4, background: 'transparent', $nest: Object.assign(Object.assign({}, SharedNode_1.NodeTitle.$nest), { '.NodeCreate': NodeCreate, '.NameErrorMessage': NameErrorMessage }) }),
        '&:hover': {
            borderColor: Colors_1.Colors.green[0],
        },
    },
};
const NodeContainer = typestyle_1.style({
    margin: 15,
    $nest: Object.assign({ '.MainNodeArea': MainNodeArea }, Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
        a[`.NodeType-${b}`] = {
            borderColor: theme_1.GraphQLBackgrounds[b],
        };
        return a;
    }, {})),
});
const PlusButton = typestyle_1.style({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    color: Colors_1.Colors.grey[0],
    border: `1px solid ${Colors_1.Colors.grey[0]}11`,
    width: 20,
    height: 20,
    borderRadius: 10,
    marginRight: 5,
});
exports.NewNode = ({ node, onCreate }) => {
    const thisNode = react_1.useRef(null);
    const [newName, setNewName] = react_1.useState('');
    const [isCreating, setIsCreating] = react_1.useState(false);
    const { libraryTree, tree, setSelectedNode } = trees_1.useTreesState();
    const isError = tree.nodes.map((n) => n.name).includes(newName) || libraryTree.nodes.map((n) => n.name).includes(newName);
    const submit = () => {
        if (newName && !isError) {
            onCreate(newName);
        }
        setNewName('');
        setIsCreating(false);
    };
    return (react_1.default.createElement("div", { className: `${NodeContainer}`, ref: thisNode, style: {} },
        react_1.default.createElement("div", { className: `MainNodeArea NodeType-${node.name}`, onClick: (e) => {
                e.stopPropagation();
                setIsCreating(true);
                setSelectedNode(undefined);
            } },
            react_1.default.createElement("div", { className: `NodeTitle` },
                isError && (react_1.default.createElement("div", { className: 'NameErrorMessage' }, `Cannot create ${node.name} with name:${newName} type with that name already exists. Try different name`)),
                !isCreating && react_1.default.createElement("div", { className: `NodeName` }, `New ${node.name}`),
                isCreating && (react_1.default.createElement("input", { className: `NodeCreate ${isError ? 'NameError' : ''}`, value: newName, autoFocus: true, placeholder: `New ${node.name} name...`, onChange: (e) => setNewName(e.target.value), onBlur: submit, onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            submit();
                        }
                    } })),
                !isCreating && (react_1.default.createElement("span", { className: `${PlusButton}` },
                    react_1.default.createElement(index_1.Plus, { width: 10, height: 10 })))))));
};
